import type { CSSProperties } from "react";
import { Outlet } from "react-router-dom";
import { AdminTabs } from "@/components/admin/AdminTabs";
import { EnvBanner } from "@/components/admin/EnvBanner";

const WRAP: CSSProperties = {
  minHeight: "100dvh",
  background: "var(--d-ink)",
  color: "var(--d-fg)",
  paddingBottom: 96,
};

export function AdminLayout(): JSX.Element {
  return (
    <div style={WRAP}>
      <EnvBanner />
      <AdminTabs />
      <Outlet />
    </div>
  );
}
